import {useUserContext} from '@containers/App/UserProvider'
import type {UserContextProps} from '@containers/App/UserProvider'
import type {FeatureFlag} from '@shared/constants/featureFlags'

export function useFeatureFlag(flag: FeatureFlag): boolean {
  // Off without a UserProvider: the public Alpinist demo embed renders the chat
  // with a minimal provider stack and no signed-in user to carry flags.
  const userContext = useUserContext() as UserContextProps | null
  return userContext?.featureFlags?.has(flag) ?? false
}
